<template>
    <div class="container" id="news-and-stories">
        <div class="row">
            <div class="col-md-12">
                <h1 class="section-title">NEWS & STORIES</h1>
            </div>
            <div class="row">
                <div
                    class="col-md-4"
                    v-for="story in row_stories"
                    v-bind:key="story.id"
                >
                    <a :href="story.slug">
                        <div class="card" style="width: 100%">
                            <div
                                class="exclusive-tag"
                                v-bind:class="{ 'd-none': !story.exclusive }"
                            >
                                HERO MEMBER EXCLUSIVE
                            </div>
                            <img
                                class="card-img-top"
                                :src="story.img"
                                alt="Card image cap"
                            />
                            <div class="card-body">
                                <p class="story-title">{{ story.title }}</p>
                                <p class="card-text">
                                    {{ strip_html(story.excerpt) }}
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row mt-4">
                <div
                    class="col-md-8 mt-2"
                    v-for="story in big_card_story"
                    v-bind:key="story.id"
                >
                    <a :href="story.slug">
                        <div
                            class="card"
                            style="width: 100%; height: 100%; margin-bottom: 0;"
                        >
                            <div
                                class="exclusive-tag"
                                v-bind:class="{ 'd-none': !story.exclusive }"
                            >
                                HERO MEMBER EXCLUSIVE
                            </div>
                            <img
                                class="card-img-top"
                                :src="story.img"
                                alt="Card image cap"
                            />
                            <div class="card-body">
                                <p class="story-title">{{ story.title }}</p>
                                <p class="card-text">
                                    {{ strip_html(story.body) }}
                                </p>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-4">
                    <div class="row">
                        <div
                            class="col-md-12"
                            v-for="(story, count) in column_stories"
                            v-bind:key="story.id"
                        >
                            <a :href="story.slug">
                                <div
                                    class="card"
                                    style="width: 100%; margin-bottom: 0; background-color:red;"
                                    :style="[
                                        count == 0
                                            ? { 'min-height': '93%' }
                                            : ''
                                    ]"
                                >
                                    <div
                                        class="exclusive-tag"
                                        v-bind:class="{
                                            'd-none': !story.exclusive
                                        }"
                                    >
                                        HERO MEMBER EXCLUSIVE
                                    </div>
                                    <img
                                        class="card-img-top"
                                        :src="story.img"
                                        alt="Card image cap"
                                    />
                                    <div class="card-body">
                                        <p class="story-title">
                                            {{ story.title }}
                                        </p>
                                        <p class="card-text">
                                            {{ strip_html(story.body) }}
                                        </p>
                                    </div>
                                </div>
                            </a>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 text-center mt-5" id="pagination-btns">
                <button
                    v-bind="[{ disabled: !prev_page_url }]"
                    @click="fetchStories(prev_page_url)"
                >
                    <span>&lt;</span>
                </button>
                <button
                    v-bind="[{ disabled: !next_page_url }]"
                    @click="fetchStories(next_page_url)"
                >
                    <span>&gt;</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: "",
            body: "",
            slug: "",
            row_stories: [],
            big_card_story: [],
            column_stories: [],
            next_page_url: "",
            prev_page_url: ""
        };
    },

    created() {
        this.fetchStories();
    },

    methods: {
        strip_html(value) {
            var div = document.createElement("div");
            div.innerHTML = value;
            var text = div.textContent || div.innerText || "";
            return text;
        },
        fetchStories(page_url) {
            let url = page_url || "/api/v1/stories/all";
            fetch(url)
                .then(res => res.json())
                .then(res => {
                    this.prev_page_url = res.prev_page_url;
                    this.next_page_url = res.next_page_url;

                    const data = res.data;
                    let row_stories = [];
                    let big_card_story = [];
                    let column_stories = [];

                    data.forEach(function(value, index) {
                        value.img = "/storage/" + value.img;
                        value.slug = "stories/" + value.slug;
                        if (index < 3) {
                            row_stories.push(value);
                        } else if (index == 3) {
                            big_card_story.push(value);
                        } else {
                            column_stories.push(value);
                        }
                    });

                    this.row_stories = row_stories;
                    this.big_card_story = big_card_story;
                    this.column_stories = column_stories;
                })
                .catch(err => console.log(err));
        }
    }
};
</script>

<style scoped>
#news-and-stories {
    padding-top: 50px;
    padding-bottom: 50px;
}
#news-and-stories .section-title {
    font-family: WWF, "Nunito", sans-serif;
    margin-bottom: 50px;
    font-size: 3rem;
}
.card {
    border: none !important;
    background-color: #f9f9f9 !important;
    margin-bottom: 10px !important;
    min-height: 100%;
}
.card .card-body {
    padding: 25px;
}
.card .card-text {
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    color: black;
    text-decoration: none;
}
.card .story-title {
    font-family: "Open Sans";
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 2px;
    color: black;
}
#news-and-stories a {
    text-decoration: none;
}
#pagination-btns button:disabled {
    border: 2px solid #dfdfdf;
    background: #dfdfdf;
}
#pagination-btns button {
    font-weight: bolder;
    font-size: 3rem;
    border-radius: 50%;
    line-height: 45px;
    width: 60px;
    height: 60px;
    color: white;
    border: none;
    font-family: "WWF";
    background-color: #f07d00;
    text-align: center;
    margin-left: 1rem;
    margin-right: 1rem;
}
#pagination-btns button span {
    position: relative;
    top: -4px;
}
.exclusive-tag {
    position: absolute;
    top: 0;
    background-color: #ffca00;
    color: white;
    padding: 5px 10px;
    font-weight: 700;
}
@media only screen and (max-width: 768px) {
}
</style>
